import request from '@/router/axios';

const pre_fix = '/dotadmin/dotadmin/flow/';

export function getFlowInfo(id) {
  return request({
    url: pre_fix + id,
    method: 'get',
  });
}

export function getFlowList(orderId) {
  return request({
    url: pre_fix + 'getFlowList/' + orderId,
    method: 'get',
  });
}

export function getByType(query) {
  return request({
    url: pre_fix + '/getByType',
    method: 'get',
    params: query,
  });
}

export function saveRemark(flowInfo) {
  return request({
    url: pre_fix + 'remark/' + flowInfo.orderId,
    method: 'post',
    data: flowInfo,
  });
}

export function check(orderId) {
  return request({
    url: pre_fix + 'check/' + orderId,
    method: 'get',
  });
}

export function addMarkingFlow(flowInfo) {
  return request({
    url: pre_fix + 'addMarkingFlow',
    method: 'post',
    params: flowInfo,
  });
}

export function addPeFlow(flowInfo) {
  return request({
    url: pre_fix + 'addPeFlow',
    method: 'post',
    params: flowInfo,
  });
}

export function statistics(obj) {
  return request({
    url: '/track/tr/dotAdmin',
    method: 'post',
    data: obj,
  });
}

export function qcUpdatePeRemark(qcTaskId, obj) {
  return request({
    url: pre_fix + 'qcUpdatePeRemark/' + qcTaskId,
    method: 'post',
    data: obj,
  });
}
